import React, { Fragment, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Modal from "./Modal";
import { Trans } from "react-i18next";

/*
    Nota mental:
    history viene de withRouter, que es un HOC que le da a los componentes acceso a la historia del navegador.
    Lo mas nuevo es usar el hook useHistory, que es mas facil de usar.
    Pero ocupas actualizar react-router-dom a la version 5.1.2 o superior.
*/

function GoBackButton({ isPayment, handleBack, history, isButtonForm, ignoreModal }) {
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (isPayment && !ignoreModal) {
      // Reemplaza la funcion de ir para atras
      window.history.pushState(null, null, window.location.pathname);
      window.addEventListener("popstate", handleEventGoBack);

      //logic for showing popup warning on page refresh
      window.onbeforeunload = function () {
        return "La reserva se perderá si recarga la página, ¿está seguro?";
      };
    }

    return () => {
      if (isPayment) {
        window.removeEventListener("popstate", handleEventGoBack);
        window.onbeforeunload = null;
      }
    };
  }, [isPayment]);

  // useEffect(() => {
  //   if (showModal) {
  //     window.removeEventListener("popstate", handleGoBack);
  //     window.onbeforeunload = null;
  //   }
  // }, [showModal]);

  const handleEventGoBack = (e) => {
    window.history.pushState(null, null, window.location.pathname);
    handleGoBack(e);
  };

  const handleGoBack = (e) => {
    if (isPayment && !ignoreModal) {
      e.preventDefault();
      // window.history.pushState(null, null, window.location.pathname);

      console.log(e);
      // alert("No puedes ir para atras");
      setShowModal(true);
    } else {
      history.goBack();
    }
  };

  const goBack = async () => {
    window.removeEventListener("popstate", handleGoBack);
    window.onbeforeunload = null;
    // history.goBack();
    if (handleBack) await handleBack();
    history.goBack();
    history.goBack();
  };

  return (
    <Fragment>
      {showModal && (
        <Modal handleBack={goBack} handleDismiss={() => setShowModal(false)} />
      )}
      {isButtonForm ? (
        <button
          type="button"
          onClick={handleGoBack}
          className="continua_button btn btn-secondary col-md-6"
        >
          <i className="fa fa-arrow-left" aria-hidden="true"></i>
          <Trans>dashboard.room_payment.btn_exit</Trans> 
        </button>
      ) : (
        <button className="btn btn-back" onClick={handleGoBack}>
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      )}
    </Fragment>
  );
}

export default withRouter(GoBackButton);



// WEBPACK FOOTER //
// ./src/components/GoBackButton/index.jsx